module.exports = __webpack_public_path__ + "img/4d77167f836ab6642938615837a766e.18bc3552.jpg";